// Icons
import { IoIosColorPalette } from 'react-icons/io';
import { MdOutlineLiveTv } from 'react-icons/md';
import { FaUserCircle } from 'react-icons/fa';
import { FaCreditCard } from 'react-icons/fa';
import { GiSettingsKnobs } from 'react-icons/gi';
import { MdLiveHelp } from 'react-icons/md';
import { FaSignOutAlt } from 'react-icons/fa';
import { FaHome, FaPlay } from 'react-icons/fa';
import { IoLogoGameControllerB } from 'react-icons/io';
import { PiMonitorPlayBold } from 'react-icons/pi';
import { SiGitbook } from 'react-icons/si';
import { LiaBookOpenSolid } from 'react-icons/lia';
import { HiPaintBrush } from 'react-icons/hi2';
import { SiMicrodotblog } from 'react-icons/si';
import { MdVideoChat } from 'react-icons/md';
import { HiMiniRectangleStack } from 'react-icons/hi2';
import { TiThSmall } from 'react-icons/ti';
import { BiMailSend } from 'react-icons/bi';
import { PiUserSwitchBold } from "react-icons/pi";
import { LuLayoutDashboard } from "react-icons/lu";

export const MenuItems = [
	{
		label: 'Home',
		icon: <FaHome size={28} />,
		link: '/home'
	},
	{
		label: 'Videos',
		icon: <FaPlay size={22} />,
		link: '/videos'
	},
	{
		label: 'Games',
		icon: <IoLogoGameControllerB size={28} />,
		link: '/games'
	},
	{
		label: 'Live TV',
		icon: <PiMonitorPlayBold size={28} />,
		link: '/live-tv'
	},
	{
		label: 'eBooks',
		icon: <SiGitbook size={28} />,
		link: '/ebooks'
	},
	{
		label: 'Quran',
		icon: <LiaBookOpenSolid size={28} />,
		link: '/quran'
	}
];

export const UserMenuOptions = {
	parent: [
        {
			label: 'Who is watching?',
			icon: <PiUserSwitchBold className={`text-2xl`} />,
			link: '/who-is-watching/'
		},
		{
			label: 'Edit Avatar',
			icon: <IoIosColorPalette className={`text-2xl`} />,
			link: '/edit-avatar'
		},
		{
			label: 'Activate TV',
			icon: <MdOutlineLiveTv className={`text-2xl`} />,
			link: '/tv-apps/verify-code/'
		},
		{
			label: 'Parent Account',
			icon: <FaUserCircle className={`text-2xl`} />,
			link: '/profile'
		},
		{
			label: 'Payment & Plan',
			icon: <FaCreditCard className={`text-2xl`} />,
			link: '/profile/payment-and-plan/'
		},
		{
			label: 'Referrals',
			icon: <BiMailSend className={`text-2xl`} />,
			link: 'https://muslim-kids-tv.getrewardful.com/signup?campaign=muslim-kids-tv-family',
			target: '_blank'
		},
		{
			label: 'Settings',
			icon: <GiSettingsKnobs className={`text-2xl`} />,
			link: '/profile/settings/'
		},
		{
			label: 'Help Center',
			icon: <MdLiveHelp className={`text-2xl`} />,
			link: 'https://help.muslimkids.tv/hc/en-us'
		},
		{
			label: 'Logout',
			icon: <FaSignOutAlt className={`text-xl`} />,
			link: '/'
		}
	],
	staff: [
        {
			label: 'Who is watching?',
			icon: <PiUserSwitchBold className={`text-2xl`} />,
			link: '/who-is-watching/'
		},
		{
			label: 'Edit Avatar',
			icon: <IoIosColorPalette className={`text-2xl`} />,
			link: '/edit-avatar'
		},
		{
			label: 'Activate TV',
			icon: <MdOutlineLiveTv className={`text-2xl`} />,
			link: '/tv-apps/verify-code/'
		},
		{
			label: 'Parent Account',
			icon: <FaUserCircle className={`text-2xl`} />,
			link: '/profile'
		},
		{
			label: 'Payment & Plan',
			icon: <FaCreditCard className={`text-2xl`} />,
			link: '/profile/payment-and-plan/'
		},
		{
			label: 'Referrals',
			icon: <BiMailSend className={`text-2xl`} />,
			link: 'https://muslim-kids-tv.getrewardful.com/signup?campaign=muslim-kids-tv-family',
			target: '_blank'
		},
		{
			label: 'Settings',
			icon: <GiSettingsKnobs className={`text-2xl`} />,
			link: '/profile/settings/'
		},
		{
			label: 'Help Center',
			icon: <MdLiveHelp className={`text-2xl`} />,
			link: 'https://help.muslimkids.tv/hc/en-us'
		},
		{
			label: 'Logout',
			icon: <FaSignOutAlt className={`text-xl`} />,
			link: '/'
		}
	],
	teacher: [
		{
			label: 'Edit Avatar',
			icon: <IoIosColorPalette className={`text-2xl`} />,
			link: '/edit-avatar'
		},
		{
			label: 'Activate TV',
			icon: <MdOutlineLiveTv className={`text-2xl`} />,
			link: '/tv-apps/verify-code/'
		},
		{
			label: 'Teacher Account',
			icon: <FaUserCircle className={`text-2xl`} />,
			link: '/profile'
		},
		{
			label: 'Referrals',
			icon: <BiMailSend className={`text-2xl`} />,
			link: 'https://muslim-kids-tv.getrewardful.com/signup?campaign=muslim-kids-tv-family',
			target: '_blank'
		},
		{
			label: 'Settings',
			icon: <GiSettingsKnobs className={`text-2xl`} />,
			link: '/profile/settings/'
		},
		{
			label: 'Help Center',
			icon: <MdLiveHelp className={`text-2xl`} />,
			link: 'https://help.muslimkids.tv/hc/en-us'
		},
		{
			label: 'Logout',
			icon: <FaSignOutAlt className={`text-xl`} />,
			link: '/'
		}
	],
	child: [
        {
			label: 'Who is watching?',
			icon: <PiUserSwitchBold className={`text-2xl`} />,
			link: '/who-is-watching/'
		},
		{
			label: 'Dashboard',
			icon: <LuLayoutDashboard className={`text-2xl`} />,
			link: '/profile'
		},
		{
			label: 'Edit Avatar',
			icon: <IoIosColorPalette className={`text-2xl`} />,
			link: '/edit-avatar'
		},
		{
			label: 'Logout',
			icon: <FaSignOutAlt className={`text-xl`} />,
			link: '/'
		}
	],
	student: [
		{
			label: 'Edit Avatar',
			icon: <IoIosColorPalette className={`text-2xl`} />,
			link: '/edit-avatar'
		},
		{
			label: 'Student Account',
			icon: <FaUserCircle className={`text-2xl`} />,
			link: '/profile'
		},
		{
			label: 'Logout',
			icon: <FaSignOutAlt className={`text-xl`} />,
			link: '/'
		}
	]
};

export const MoreMenuOptions = [
	// {
	// 	label: 'Create',
	// 	icon: <HiPaintBrush className={`text-xl`} />,
	// 	link: '/contest'
	// },
	{
		label: 'Blog',
		icon: <SiMicrodotblog className={`text-xl`} />,
		link: 'https://resources.muslimkids.tv/'
	},
	// {
	// 	label: 'Webinars',
	// 	icon: <MdVideoChat className={`text-xl`} />,
	// 	link: '/webinars'
	// },
	{
		label: 'My List',
		icon: <HiMiniRectangleStack className={`text-xl`} />,
		link: '/my-list'
	},
	{
		label: 'All Shows',
		icon: <TiThSmall className={`text-xl`} />,
		link: '/all/shows'
	}
];
